import { getLocalStorageObject } from '../modules/form-helpers';

document.addEventListener('alpine:init', () => {
  Alpine.data('popup', () => ({
    showPopup: false,
    formName: '',
    formURL: '',
    init() {
      this.checkFormCompletion();
      this.setBodyClass();
    },
    checkFormCompletion() {
      const storeData = JSON.parse(localStorage.getItem('gd_abandonment_f'));

      if (!this.isFormResumePage() && storeData) {
        this.formName = Object.keys(storeData)[0].replaceAll('-', ' ');
        this.formURL = Object.values(storeData)[0].url;

        this.showPopup = true;
      }
    },
    closePopup() {
      localStorage.removeItem('gd_abandonment_f');
      this.showPopup = false;
    },
    continueEditing() {
      if (this.formURL) {
        // go to the form url
        window.location.href = this.formURL;

        this.showPopup = false;
      }
    },
    isFormResumePage() {
      const abandonmentStorage = getLocalStorageObject('gd_abandonment_f');

      if (abandonmentStorage && Object.keys(abandonmentStorage).length) {
        const formData = Object.values(abandonmentStorage)[0];

        if (!formData.url) {
          return false;
        }

        const formUrl = new URL(formData.url);
        const currentUrl = new URL(window.location.href);

        if (
          formUrl.pathname !== currentUrl.pathname ||
          formUrl.hostname !== currentUrl.hostname
        ) {
          // Not the page with the form
          return false;
        }

        return true;
      }

      return false;
    },
    setBodyClass() {
      document.body.classList.toggle('has-pop-up', this.showPopup);
    },
  }));
});
